<template>
    <div class="columns">
        <div class="column is-flex is-align-items-center header">
            <h1 class="is-flex-grow-1">
                {{ translate("announcer_board.title") }}
            </h1>
            <div class="buttons">
                <button v-if="store.isTimerRunning" class="mb-0 button is-danger is-rounded" @click="stopTimer">
                    <span class="icon">
                        <i class="fa fa-square"></i>
                    </span>
                    <span>{{ translate("announcer_board.stop_timer") }}</span>
                </button>
                <button v-else class="mb-0 button is-success is-rounded" @click="startTimer">
                    <span class="icon">
                        <i class="fa fa-play"></i>
                    </span>
                    <span>{{ translate("announcer_board.start_timer") }}</span>
                </button>
            </div>
            <div class="is-size-5 has-text-warning has-text-weight-bold ml-5 timer">
                <span class="icon">
                    <i class="fa fa-sync-alt" />
                </span>
                <span>{{ store.timer }} {{ translate("announcer_board.seconds_left") }}</span>
            </div>
            <div class="ml-5">
                <QueryInput v-model="store.searchQuery" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import QueryInput from "../Common/QueryInput.vue";
    import { useAnnouncerBoardStore } from "./announcerBoardStore";
    import translatorMixin from "../Common/translatorMixin";

    const { translate } = translatorMixin.methods;
    const store = useAnnouncerBoardStore();

    function stopTimer() {
        store.isTimerRunning = false;
    }

    function startTimer() {
        store.isTimerRunning = true;
    }
</script>

<style scoped></style>
